import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope, selectReadOnly } from '../../../../util/useSelectorFunctions';
import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import {
    defaultVerificationMetricResource,
    useVerificationMetricActions,
    VerificationMetricMutationResourceSchema,
} from '../../../../../resource/resources/artifacts/verification_metric/verificationMetricResource';
import { QueryBaseComponent } from '../../../../../../../react-commons/query/QueryBaseComponent';
import { Form_EditableViewWrapper } from '../../../../reusable-components/form-components/Form_EditableViewWrapper';
import { ResourceValidationTitleBar } from '../../../../reusable-components/validation/ResourceValidationTitleBar';
import { VerificationMetricContent } from './VerificationMetricContent';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import { Text } from '@mantine/core';

export const VerificationMetricView = ({ id }: { id: string | undefined }) => {
    const readOnly = useSelector(selectReadOnly);
    const validationScope = useSelector(selectNoScopeValidationScope);

    const verificationMetricActions = useVerificationMetricActions()
    const verificationMetricQuery = verificationMetricActions.useGetResource(id);
    const updateVerificationMetric = verificationMetricActions.useUpdateResource();
    const validateVerificationMetric = verificationMetricActions.useValidateResource(id, validationScope);

    const { form, formNames, onSubmit } = useMyForm({
        schema: VerificationMetricMutationResourceSchema,
        defaultValues: defaultVerificationMetricResource,
        submitHandler: async (data) => {
            await updateVerificationMetric.mutateAsync({
                resource: data,
                id: data.id,
            });
        },
        reactiveValues: verificationMetricQuery.data,
    });

    return (
        <QueryBaseComponent name="VerificationMetric" query={verificationMetricQuery}>
            <Form_EditableViewWrapper form={form} onSubmit={onSubmit}>
                <ResourceValidationTitleBar
                    resourceValidationResult={validateVerificationMetric.data}
                    metaDataInfo={verificationMetricQuery.data}
                    resourceType={ResourceType.VERIFICATION_METRIC}
                >
                    <Text c="dimmed">Verification Metric</Text>
                </ResourceValidationTitleBar>
                <VerificationMetricContent form={form} formNames={formNames} id={id} readOnly={readOnly} />
            </Form_EditableViewWrapper>
        </QueryBaseComponent>
    );
};
